export default function (menuSelected = 'today', action) {
    if (action.type == 'currentSelection') {
        return action.currentSelected
    } else {
        return menuSelected;
    }
}